export const AG_MDS_COLUMN_HEADER_CLASS = 'ag-mds-column-header';

/**
 * Calculated columns need their own class for the borders that mark them out, but a `cellClass` on
 * a colDef replaces the one contributed by the `numericColumn` column type rather than adding to
 * it. Naming both keeps the alignment and tabular figures that every other value cell gets from
 * `ag-right-aligned-cell`. AG Grid splits on whitespace when it applies the class.
 */
export const CALCULATION_CELL_CLASS = 'ag-right-aligned-cell ag-expression-column';
